module.exports = __webpack_public_path__ + "img/order-case01.6fd48e0a.jpeg";